import React from 'react';
import dict from '../../dictionary';
import trans from '../../translations.json';
import OverviewTables from '../overview/overviewTables';

import ReducedData from '../../reducedData.json';
import OnThisPage from '../onThisPage/onThisPage';
import { round } from '../utils';

var MLTCData = Object.values(ReducedData.dataMLTCsummary);

let latestData = { ...MLTCData[MLTCData.length - 1] };
let previousData = { ...MLTCData[MLTCData.length - 2] };

let overviewInOutbreak = latestData[dict.ltc_homes_active];
let percentageInOutbreak = round((overviewInOutbreak / 626) * 100, 1);

let overviewNotOutbreak = 626 - overviewInOutbreak;
let percentageNotOutbreak = round(
  (overviewNotOutbreak / 626) * 100,
  1,
);

let prevInOutbreak = previousData[dict.ltc_homes_active];
let prevNotOutbreak = 626 - prevInOutbreak;

var covidData = ReducedData.covidData;
var POHData = [...covidData].filter(
  (item) => item[dict.ltc_total_residents],
);

let latestCases = { ...POHData[POHData.length - 1] };
let previousCases = { ...POHData[POHData.length - 2] };

let overviewResidentTotal = latestCases[dict.ltc_total_residents];
let overviewStaffTotal = latestCases[dict.ltc_total_staff];

let prevResidentTotal = previousCases[dict.ltc_total_residents];
let prevStaffTotal = previousCases[dict.ltc_total_staff];

let overviewResDeaths = latestData[dict.mltc_total_residents_deaths];
let overviewStaffDeaths = Number(
  latestData[dict.mltc_total_staff_deaths],
);

let previousOverviewResDeaths =
  previousData[dict.mltc_total_residents_deaths];
let previousOverviewStaffDeaths = Number(
  previousData[dict.mltc_total_staff_deaths],
);

const totalSince = 'January 15, 2020';

const Header = (props) => {
  const lang = props.lang;
  const stats = {
    curr: [
      {
        label: trans.ltc.homeOutbreaks[lang],
        value:
          overviewInOutbreak + ' (' + percentageInOutbreak + '%)',
        difference:
          Number.isInteger(overviewInOutbreak) &&
          Number.isInteger(prevInOutbreak)
            ? overviewInOutbreak - prevInOutbreak
            : 0,
      },
      {
        label: trans.ltc.homeNotOutbreaks[lang],
        value:
          overviewNotOutbreak + ' (' + percentageNotOutbreak + '%)',
        difference:
          Number.isInteger(overviewNotOutbreak) &&
          Number.isInteger(prevNotOutbreak)
            ? overviewNotOutbreak - prevNotOutbreak
            : 0,
      },
    ],
    cumm: [
      {
        label: trans.ltc.residentTotal[lang],
        value: overviewResidentTotal,
        difference:
          Number.isInteger(overviewResidentTotal) &&
          Number.isInteger(prevResidentTotal)
            ? overviewResidentTotal - prevResidentTotal
            : 0,
      },
      {
        label: trans.ltc.staffTotal[lang],
        value: overviewStaffTotal,
        difference:
          Number.isInteger(overviewStaffTotal) &&
          Number.isInteger(prevStaffTotal)
            ? overviewStaffTotal - prevStaffTotal
            : 0,
      },
      {
        label: trans.ltc.ltcResidentDeathsTotal[lang],
        value: overviewResDeaths,
        difference:
          Number.isInteger(overviewResDeaths) &&
          Number.isInteger(previousOverviewResDeaths)
            ? overviewResDeaths - previousOverviewResDeaths
            : 0,
      },
      {
        label: trans.ltc.ltcStaffDeathsTotal[lang],
        value: overviewStaffDeaths,
        difference:
          Number.isInteger(overviewStaffDeaths) &&
          Number.isInteger(previousOverviewStaffDeaths)
            ? overviewStaffDeaths - previousOverviewStaffDeaths
            : 0,
      },
    ],
  };

  return (
    <div>
      <OverviewTables
        stats={stats}
        lang={lang}
        lastUpdated={props.lastUpdated}
        totalSince={totalSince}
        withLegend={true}
        isLTC={true}
        labels={[trans.ltc.currentOutbreaks[lang]]}
        descs={[trans.ltc.totalHomes[lang]]}
      />
      <hr aria-hidden="true" className="ontario-thick"></hr>
      <OnThisPage
        lang={lang}
        sections={[
          {
            href: '#casestatus',
            category: 'otp',
            text: 'byNumbers2',
          },
          {
            href: '#where_numbers',
            category: 'otp',
            text: 'numberscomefrom',
          },
        ]}
      />
    </div>
  );
};

export default Header;
